import TwoColumnLayout from './TwoColumnLayout';

export { type TwoColumnLayoutProps } from './TwoColumnLayout';
export default TwoColumnLayout;
